import React, { useState } from "react";

import { InboxOutlined } from "@ant-design/icons";
import { Upload } from "antd";

const { Dragger } = Upload;

const FileUploaderComponent = ({ label, onFileUpload }) => {
  const [uploadedFile, setUploadedFile] = useState(null);

  const beforeUpload = (file) => {
    // Ensure the file is a raw File object
    const sanitizedFileName = file.name.replace(/\s+/g, "");
    const processedFile = new File([file], sanitizedFileName, {
      type: file.type,
    });

    setUploadedFile(processedFile);
    onFileUpload(processedFile);

    return false; // Prevent automatic upload
  };

  const handleRemove = () => {
    setUploadedFile(null);
    onFileUpload(null);
  };

  return (
    <div className="w-full">
      <Dragger
        name="file"
        multiple={false}
        beforeUpload={beforeUpload}
        onRemove={handleRemove}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined
            style={{ fontSize: "24px", color: "hsl(var(--brand-primary))" }}
          />
        </p>
        <p className="ant-upload-text">Click or drag file to upload</p>
        <p className="ant-upload-hint">{label}</p>
      </Dragger>
    </div>
  );
};

export default FileUploaderComponent;
